export const transformToKeyValue = <D extends Record<string, any>>(key: keyof D) => (data: D[]) => {
  const keyValue: { [k: string]: D } = {};
  data.forEach(item => {
    if (key in item) {
      keyValue[item[key]] = item;
    }
  })
  return keyValue;
}
